import React, { useState } from 'react';
import _cloneDeep from 'lodash/cloneDeep';

import MapController from '../../controllers/MapController';

import './annotation-popup.scss';

const AnnotationPopUp = ({ graphic, close }: { graphic: __esri.Graphic; close: Function }) => {
  const { attributes } = graphic;
  // LOCAL STATE
  const [editMode, setEditMode] = useState(attributes.editMode);
  const [editedAttributes, setEditedAttributes] = useState(attributes); // these attributes are locally changed attributes that haven't been saved yet

  /**
   * function to update a specific property when in edit mode
   * @param key - string to find value on editedAttributes
   * @param value - value to update on editedAttributes
   */
  const setValue = (key: string, value: string | boolean) => {
    const updatedAttributes = _cloneDeep(editedAttributes);

    updatedAttributes[key] = value;
    setEditedAttributes(updatedAttributes);
  };

  /**
   * function to cancel any changes and close popup
   */
  const closePopup = () => {
    cancel(); // to ignore any unsaved changes
    close();
  };

  /**
   * function to save updated information for an annotation
   */
  const save = () => {
    const tempAttributes = JSON.parse(JSON.stringify(editedAttributes));
    tempAttributes.editMode = false;
    MapController.updateAnnotationGraphicsInfo(editedAttributes);
    setEditMode(false);
  };

  /**
   * function to cancel/nullify any unsaved changes on an annotation
   */
  const cancel = () => {
    // we want to use the original attributes that came in case the user closes the popup and doesn't want to save
    // this nullifies any unsaved changes and keeps the original attributes intact.
    const tempAttributes = JSON.parse(JSON.stringify(attributes));
    tempAttributes.editMode = false;
    MapController.updateAnnotationGraphicsInfo(tempAttributes);
    setEditMode(false);
  };

  /**
   * render function to show popup contents in the edit form state
   */
  const editContents = () => {
    return (
      <React.Fragment>
        <input
          type='text'
          placeholder='Subject line of annotation'
          value={editedAttributes.title}
          onChange={(e) => setValue('title', e.target.value)}
        />
        <textarea placeholder='' value={editedAttributes.desc} onChange={(e) => setValue('desc', e.target.value)} />
        <div className='popup-controls'>
          <button onClick={() => cancel()}>Cancel</button>
          <button onClick={() => save()}>Save</button>
        </div>
      </React.Fragment>
    );
  };

  /**
   * render function to show popup contents in the view state
   */
  const popupContents = () => {
    return (
      <React.Fragment>
        <div className='popup-title'>{attributes.title}</div>
        <div className='popup-desc'>{attributes.desc}</div>
      </React.Fragment>
    );
  };

  return (
    <div className='popup' key={attributes.id}>
      <span className='esri-icon-close' onClick={() => closePopup()} />
      {editMode ? editContents() : popupContents()}
    </div>
  );
};

export default AnnotationPopUp;
